import './StoryFeature.css'
import React from "react";
import rectangle1 from '../../assets/images/rectangle1.png';
import featuredStory from '../../assets/images/featuredStory.png';
import readHere from '../../assets/images/readHere.png';

function Graphs(props) {
    return (
            <div className="graphBody">
                <div className="colorBackdrop"></div>
                <h1 className="featuredStoryHeader"> FEATURED STORY </h1>
                <img className="featuredStoryImage" src={featuredStory} alt="featured story: women in typography - click to read story!"/>
                <a href="story/eflorals">
                    <img className="readHereImage" src={readHere} alt="read here wrapped in a vintage banner"/>
                </a>
                <img className="graphRectangle" src={rectangle1} alt="rectangle"/>
            </div>
    )

}

export default Graphs;